<div id="container"  [hidden]="!isLoading">
    <div class="loading-classement text-center">
        <img src="../../assets/images/ring-spinner.gif" alt="spinner" width="120" height="120">
          <p class="blinking">Chargement des données des clients ...</p>
      </div>
</div>